import { Source } from "@opendash/core/dist/types-generated";
import Parse from "parse";
import { useEffect, useState } from "react";
import { Item } from "../../../js/parsegenerated";

export const useItemsForSources = (sources: Source[] | string[]) => {
  const [items, setItems] = useState<Item[]>([]);

  useEffect(() => {
    const sourceIds = sources.map((source: Source | string) =>
      typeof source === "object" ? source.id : source
    );
    const itemQuery = new Parse.Query(Item).include("sources");
    let sourceQuery = new Parse.Query(Source).containedIn(
      "objectId",
      sourceIds
    );

    itemQuery.matchesQuery("sources", sourceQuery);
    itemQuery.find().then((items) => setItems(items));
  }, [sources]);

  return items;
};
